// let currentlyActiveAccordionItem = null;
//   const accordionItemHeaders = document.querySelectorAll(".accordian-wrap .accordian-title");
//   accordionItemHeaders.forEach(accordionItemHeader => {
//     accordionItemHeader.addEventListener("click", event => {
//       if (currentlyActiveAccordionItem && currentlyActiveAccordionItem !== accordionItemHeader) {
//         currentlyActiveAccordionItem.classList.remove("active");
//         const previouslyActiveAccordionItemBody = currentlyActiveAccordionItem.nextElementSibling;
//         previouslyActiveAccordionItemBody.style.maxHeight = 0;
//       }
//       accordionItemHeader.classList.toggle("active");
//       currentlyActiveAccordionItem = accordionItemHeader;
//       const accordionItemBody = accordionItemHeader.nextElementSibling;
//       if (accordionItemHeader.classList.contains("active")) {
//         accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
//       } else {
//         accordionItemBody.style.maxHeight = 0;
//       }
//     });
//   });

// function accordian(){
//   const accordions = document.querySelectorAll(".accordian-wrap");
//   const openAccordion = (accordion) => {
//     const content = accordion.querySelector(".accordian-content");
//     accordion.classList.add("active");
//     content.style.maxHeight = content.scrollHeight + "px";
//   };
//   const closeAccordion = (accordion) => {
//     const content = accordion.querySelector(".accordian-content");
//     accordion.classList.remove("active");
//     content.style.maxHeight = null;
//   };
//   var first_accordian = document.querySelector(".accordian-wrap");
//   if(first_accordian){
//     var first_content = first_accordian.querySelector(".accordian-content");    
//   }
//   if(first_content){
//     first_content.style.maxHeight = first_content.scrollHeight + "px";
//   }
//   accordions.forEach((accordion) => {
//     const intro = accordion.querySelector(".accordian-title");
//     const content = accordion.querySelector(".accordian-content");
//     intro.onclick = () => {
//       if (content.style.maxHeight) {
//         closeAccordion(accordion);
//       } else {
//         accordions.forEach((accordion) => closeAccordion(accordion));
//         openAccordion(accordion);
//       }
//     };
//   });
// }
// accordian();
// document.addEventListener("shopify:section:load", function(event) {
//   accordian();
// });


// document.querySelectorAll('.accordian-wrap').forEach(function(accordion) {
//   accordion.addEventListener('click', function() {
//     if (this.classList.contains('active')) {
//       this.classList.remove('active');
//     } else {
//       this.parentElement.querySelectorAll('.accordian-wrap.active').forEach(function(sibling) {
//         sibling.classList.remove('active');
//       });
//       this.classList.add('active');
//     }
//   });
// });



document.querySelectorAll('.accordian-wrap').forEach(function(accordion) {
  accordion.addEventListener('click', function() {
    if (this.classList.contains('active')) {
      this.classList.remove('active');
    } else {
      document.querySelectorAll('.accordian-wrap.active').forEach(function(openAccordion) {
        openAccordion.classList.remove('active');
      });
      this.classList.add('active');
    }
  });
});
